// extracted by css-extract-rspack-plugin
export default {"selectedValues":"selectedValues-1ZTxB","selectedLimitToggle":"selectedLimitToggle-Yowcs","outsideTags":"outsideTags-2y0Ph","icon":"icon-3gVu3"};